import { getFilterIndicator } from "../helpers";

import type { FilterStrategy } from "./types";

export const multiselectStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (!filterType.options || filterType.options.length === 0) return;
    const q = ctx.query;
    for (const option of filterType.options) {
      if (option.label.toLowerCase().includes(q)) {
        const isExact = option.label.toLowerCase() === q;
        out.push({
          filterKey: filterType.filterKey,
          filterLabel: filterType.label,
          optionValue: option.value,
          optionLabel: option.label,
          type: filterType.type,
          score: isExact ? 90 : 70,
          indicator: getFilterIndicator(filterType),
        });
      }
    }
  },
  isSelected(currentValue, optionValue) {
    if (Array.isArray(currentValue)) {
      return currentValue.includes(optionValue);
    }
    return currentValue === optionValue;
  },
  toggle(result, currentValue) {
    const currentArray = Array.isArray(currentValue) ? currentValue : [];
    const isSelected = currentArray.includes(result.optionValue);
    if (isSelected) {
      const next = currentArray.filter((v) => v !== result.optionValue);
      return { value: next.length > 0 ? next : undefined };
    }
    return { value: [...currentArray, result.optionValue] };
  },
};
